import { render, staticRenderFns } from "./NovoUsuario.vue?vue&type=template&id=1864946a"
import script from "./NovoUsuario.vue?vue&type=script&lang=ts"
export * from "./NovoUsuario.vue?vue&type=script&lang=ts"
import style0 from "./NovoUsuario.vue?vue&type=style&index=0&id=1864946a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports